import React from "react";
import "./Footer.css";

import MailIcon from "../assets/footer/mail.svg";
import PhoneIcon from "../assets/footer/phone.svg";
import Logo from "../assets/logo.png";
import ADproIcon from "../assets/ADprocolor.webp";

const handleEmailClick = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "email_click",
      link_url: "mailto:contactus@metaguise.com",
    });
  }
};

const handlePhoneClick = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "phone_click",
      link_url: "tel:981-160-4449",
    });
  }
};

const Footer = () => {
  return (
    <footer className="tw-mt-14 tw-pb-8 tw-max-w-[1100px] tw-mx-auto tw-px-4">
    <div className="Desk-footer">
    <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-items-start md:tw-items-start tw-gap-8 md:tw-gap-32 font ">
        {/* Image 1 */}
       <div className="tw-flex tw-items-center tw-gap-4">
  <img
    className="tw-w-32 md:tw-w-40"
    src={Logo}
    alt="METAGUISE Logo"
    width={160}
    height={50}
    loading="lazy"
  />

<a href=" https://www.architecturaldigest.in/adpro/directory/profile/metaguise/" style={{ display: "inline-block" }}>
  <img
    className="tw-w-[100px]"
    src={ADproIcon}
    alt="ADpro Logo"
    style={{ cursor: "pointer" }}
    width={100}
    height={40}
    loading="lazy"
  />
</a>

</div>

        <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start tw-gap-8 md:tw-gap-32">
          {/* Home Links */}
          <div className="tw-text-base tw-flex tw-flex-col tw-items-center md:tw-items-start tw-text-center md:tw-text-right footer-links ">
            <a href="/">Home</a>
            <a href="/all-projects/">Projects</a>
            <a href="/all-products/">Products</a>
          </div>
          {/* About Links */}
          <div className="tw-text-base tw-flex tw-flex-col tw-items-center md:tw-items-start footer-links col-xl-3">
            <a href="/about/">About Us</a>
            <a href="/contact/">Talk to Us</a>
            <a href="/partner/">Partner With Us</a>
          </div>
          {/* Contact Links */}
          <div className="tw-flex tw-text-base tw-flex-col tw-items-center md:tw-items-start tw-gap-4 footer-links col-lg-10 col-xl-6">
            <div className="tw-flex tw-items-center tw-gap-2">
              <img src={PhoneIcon} alt="mail" width={20} height={20} loading="lazy" />
              <a
                href="mailto:contactus@metaguise.com"
                className="tw-text-sm md:tw-text-base"
                onClick={handleEmailClick}
              >
                contactus@metaguise.com
              </a>
            </div>

            <div className="tw-flex tw-gap-4">
              <img src={MailIcon} alt="phone" width={20} height={20} loading="lazy" />
              <a
                href="tel:981-160-4449"
                className="tw-text-sm md:tw-text-base"
                onClick={handlePhoneClick}
              >
                981-160-4449 
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

      {/* {Mobile Version Footer} */}

    <div className="Mob-footer">
 

      <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-items-center md:tw-items-start tw-gap-8 md:tw-gap-32 font  ">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start tw-gap-8 md:tw-gap-32 section-1 ">
       
        <img
          id="footer-logo"
          className="tw-w-32 md:tw-w-40 "
          src={"https://ik.imagekit.io/ylx9qggcp/download%20(1).png"}
          alt="METAGUISE Logo"
          width={160}
          height={50}
          loading="lazy"
        />
      <img
        id="footer-logo"
        className="tw-w-32 md:tw-w-40 "
        src="https://ik.imagekit.io/ylx9qggcp/ADprocolor%20(2).png"
        alt="METAGUISE Logo"
        width={160}
        height={50}
        loading="lazy"
      />
   {/* Contact Links */}
   <div className="tw-flex tw-text-base tw-flex-col tw-items-center md:tw-items-start tw-gap-4 footer-links col-lg-10 col-xl-6">
            <div className="tw-flex tw-items-center tw-gap-2">
              <img src={PhoneIcon} alt="mail" width={20} height={20} loading="lazy" />
              <a
                href="mailto:contactus@metaguise.com"
                className="tw-text-sm md:tw-text-base"
                onClick={handleEmailClick}
              >
                contactus@metaguise.com
              </a>
            </div>

            <div className="tw-flex tw-gap-4">
              <img src={MailIcon} alt="phone" width={20} height={20} loading="lazy" />
              <a
                href="tel:981-160-4449"
                className="tw-text-sm md:tw-text-base"
                onClick={handlePhoneClick}
              >
                981-160-4449 
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-center tw-items-center md:tw-items-start tw-gap-8 md:tw-gap-32 font  ">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start tw-gap-8 md:tw-gap-32 section-2 ">
          {/* Home Links */}
          <div className="tw-text-base tw-flex tw-flex-col tw-items-center md:tw-items-start tw-text-center md:tw-text-right footer-links ">
            <a href="/">Home</a>
            <a href="/all-projects/">Projects</a>
            
          </div>
          {/* About Links */}
          <div className="tw-text-base tw-flex tw-flex-col tw-items-center md:tw-items-start footer-links col-xl-3">
          <a href="/all-products/">Products</a>
            <a href="/about/">About Us</a>
            
          </div>

            {/* About Links */}
            <div className="tw-text-base tw-flex tw-flex-col tw-items-center md:tw-items-start footer-links col-xl-3">
            
            <a href="/contact/">Talk to Us</a>
            <a href="/partner/">Partner With Us</a>
          </div>
       
        </div>
      </div>
    </div>
    </footer>

    
  );
};

export default Footer;